import Vue from 'vue';

const Page = Vue.component('page', {
    name: 'Page',
    delimiters: ['${', '}'],

    components: {
        // 'homepage-hero': require('./../../components/homepage-hero')
    },

    mounted() {
        Vue.nextTick(() => {
            window.requestAnimationFrame(() => {
                EventBus.$emit('page-transition-enter');
            });
        });
    },

    methods: {
        toggleShowreel() {

        }
    }
});

export default Page;